export default "__VITE_ASSET__BdkrueKf__"